<template>
    <div id="detail-doctor">
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-6"><h4 class="smalltitle">Detail Physician - {{ user.fullName }}</h4></div>
                </div>
            </div>
            <div class="modal-header with-nav">
                <ul class="nav nav-tabs">

                    <li :class="{'wdropdown' : true ,'cur': isActiveAccountSetting }"
                        class="tab-item"
                        @mouseover="openAccountSetting = true"
                        @mouseleave="openAccountSetting = false"
                    >
                        <div class="dropdown">
                            <span class="header-item">Account Setting</span>
                            <div class="dropdown-content" v-bind:style='{"display" : (openAccountSetting ? "block" : "none" )}'>
                                <div class="header-item" @click="selectTab(1)">Profile Setting</div>
                                <div class="header-item" @click="selectTab(7)">Financial Information</div>
                            </div>
                        </div>
                    </li>
                    <li :class="{'wdropdown' : true, 'cur': isActivePersonalInformation  }"
                        class="tab-item"
                        @mouseover="openPersonalInformation = true"
                        @mouseleave="openPersonalInformation = false"
                    >
                        <div class="dropdown">
                            <span class="header-item">Personal Information</span>
                            <div class="dropdown-content" v-bind:style='{"display" : (openPersonalInformation ? "block" : "none" )}'>
                                <div class="header-item" @click="selectTab(2)">General Info</div>
                                <div class="header-item" @click="selectTab(3)">Education</div>
                                <div class="header-item" @click="selectTab(4)">Position and Appointment</div>
                                <div class="header-item" @click="selectTab(5)">Publications</div>
                            </div>
                        </div>
                    </li>
                    <li :class="{'wdropdown' : true , 'cur': isActiveClinicLocation}"
                        class="tab-item"
                    >
                        <div class="dropdown">
                            <span class="header-item" @click="selectTab(6)">Clinic Locations</span>
                        </div>
                    </li>
                    <li :class="{'wdropdown' : true , 'cur': isActiveEmrSetup }"
                        class="tab-item"
                        @mouseover="openEmrSetup = true"
                        @mouseleave="openEmrSetup = false"
                    >
                        <div class="dropdown">
                            <span class="header-item">EMR Setup</span>
                            <div class="dropdown-content" v-bind:style='{"display" : (openEmrSetup ? "block" : "none" )}'>
                                <div class="header-item" @click="selectTab(8)">Credentials</div>
                                <div class="header-item" @click="selectTab(9)">CME</div>
                                <div class="header-item" @click="selectTab(10)">ID Proofing</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="content-tab">
                <tab-account-setting v-if="selectedTab === 1"
                                     :userInfo="userInfo"
                                     :payments="payments"
                                     :staffClinic="staffClinic"
                                     :user="user"
                                     :addressBillings="addressBillings"
                                     :disabledForm="disabledForm"
                                     :checkingAccounts="checkingAccounts"></tab-account-setting>
                <payment-setting-block
                        v-if="selectedTab === 7"
                        :payments="payments" :addressBillings="addressBillings"
                        :checkingAccounts="checkingAccounts"
                        :disabledForm="disabledForm">

                </payment-setting-block>
                <tab-general-info
                        v-if="selectedTab === 2"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-general-info>

                <tab-education
                        v-if="selectedTab === 3"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-education>
                <tab-position-appointment
                        v-if="selectedTab === 4"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-position-appointment>
                <tab-publication
                        v-if="selectedTab === 5"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-publication>
                <tab-clinic-location
                        v-if="selectedTab === 6"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-clinic-location>

                <tab-credential v-if="selectedTab === 8" :userInfo="userInfo"></tab-credential>
                <tab-cme v-if="selectedTab === 9" :userInfo="userInfo"></tab-cme>
                <tab-id-proofing v-if="selectedTab === 10" :userInfo="userInfo"></tab-id-proofing>
            </div>
            <div slot="footer">
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import httpClient from '../../../client'
import DetailRegularUserMixin from '../../../mixins/user/UserStatusMixin'
import TabAccountSetting from './tab-doctor/TabAccountSetting'
import TabGeneralInfo from './tab-doctor/TabGeneralInfo'
import TabEducation from './tab-doctor/TabEducation'
import TabPositionAppointment from './tab-doctor/TabPositionAppointment'
import TabPublication from './tab-doctor/TabPublication.vue'
import TabClinicLocation from './tab-doctor/TabClinicLocation'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'
import PaymentSettingBlock from './PaymentSettingBlock.vue'
import TabCme from './tab-doctor/TabCme.vue'
import TabCredential from './tab-doctor/TabCredential.vue'
import TabIdProofing from './tab-doctor/TabIdProofing.vue'
export default {
  name: 'DetailDoctor',
  components: { TabAccountSetting,
    TabGeneralInfo,
    TabEducation,
    TabPositionAppointment,
    TabPublication,
    TabClinicLocation,
    PaymentSettingBlock,
    TabCme,
    TabCredential,
    TabIdProofing },
  props: {
    user: {}
  },
  mixins: [DetailRegularUserMixin, CommonMixin],
  data () {
    return {
      modal: false,

      openAccountSetting: false,
      openPersonalInformation: false,
      openEmrSetup: false,

      selectedTab: 1,

      userInfo: {},
      profile: {},
      staffClinic: null,

      payments: [],
      addressBillings: [],
      checkingAccounts: []
    }
  },
  computed: {
    disabledForm () {
      return true
    },
    isActiveAccountSetting () {
      return [1, 7].indexOf(this.selectedTab) > -1
    },
    isActivePersonalInformation () {
      return [2, 3, 4, 5].indexOf(this.selectedTab) > -1
    },
    isActiveClinicLocation () {
      return [6].indexOf(this.selectedTab) > -1
    },
    isActiveEmrSetup () {
      return [8, 9, 10].indexOf(this.selectedTab) > -1
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getInfoAccount()
  },
  beforeDestroy () {
  },
  methods: {
    closeModal () {
      this.modal = false
    },
    selectTab (value) {
      this.selectedTab = Number(value)
    },
    async getInfoAccount () {
      try {
        let response = await httpClient.get('/users/detail-user/' + this.user.id + '?type=doctor')
        if (response.data.s === 200) {
          this.userInfo = response.data.data.user
          this.payments = response.data.data.payments
          this.addressBillings = response.data.data.addressBillings
          this.checkingAccounts = response.data.data.checkingAccounts
          this.staffClinic = response.data.data.staffClinic
        } else {
          this.alertError(response.data.msg)
          this.modal = false
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">
    .tab-item {
        cursor: pointer;
    }
    .header-item {
        padding: 10px 15px;
        display: block;
    }
    .dropdown-content {
        left: 5px !important;
    }
    .tab-item:hover .dropdown > .header-item{
        background: #d9df20;
        color: #fff;
        border-color: #d9df20;
    }
    .tab-item.cur .dropdown > .header-item{
        background: #fff;
        color: #bec500;
    }
    .dropdown-content > .header-item:hover {
        color: #fff;
        background: #d9df20;
    }
</style>
